import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import IndexPage from 'flarum/forum/components/IndexPage';
import HeaderSecondary from 'flarum/forum/components/HeaderSecondary';
import LinkButton from 'flarum/common/components/LinkButton';
import Button from 'flarum/common/components/Button';
import ResourcesPage from './pages/ResourcesPage';
import ResourceDetailPage from './pages/ResourceDetailPage';
import ResourceComposerModal from './components/ResourceComposerModal';

app.initializers.add('treasuregrove-resource-hub', () => {
  app.routes.resources = { path: '/resources', component: ResourcesPage };
  app.routes.resource = { path: '/resource/:id', component: ResourceDetailPage };

  extend(IndexPage.prototype, 'navItems', function (items) {
    items.add(
      'resources',
      LinkButton.component(
        {
          href: app.route('resources'),
          icon: 'fas fa-cubes',
        },
        app.translator.trans('treasuregrove-resource-hub.forum.nav.resources')
      ),
      90
    );
  });

  // 「发布资源」按钮：在渲染回调内检查权限（初始化阶段 app.forum 尚未就绪）
  extend(HeaderSecondary.prototype, 'items', function (items) {
    if (app.forum?.attribute('resourceHub')?.canCreate) {
      items.add(
        'resourceHubCreate',
        Button.component(
          {
            className: 'Button Button--primary',
            icon: 'fas fa-plus',
            onclick: () => app.modal.show(ResourceComposerModal),
          },
          app.translator.trans('treasuregrove-resource-hub.forum.composer.create')
        ),
        10
      );
    }
  });
});
